import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { medispanStagingStyles } from './index.styles';

interface IRejectionReasonModalProps extends WithStyles<typeof medispanStagingStyles> {
  open: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

const RejectionReasonModal = (props: IRejectionReasonModalProps): JSX.Element => {
  const { classes, open, onClose, onSubmit } = props;
  const [reason, setReason] = React.useState<string>('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(reason);
    setReason('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reject Medispan Staging Changes</DialogTitle>
      <DialogContent>
        <TextField
          className={classes.rejectReasonField}
          label="Rejection Reason"
          multiline
          rows={4}
          fullWidth
          value={reason}
          onChange={e => setReason(e.target.value)}
          variant="outlined"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" color="error" disabled={!reason.trim()} onClick={handleSubmit}>
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const RejectionReasonModalStyled = withStyles(medispanStagingStyles)(RejectionReasonModal);
